import { t } from './i18n.js';

/** Añade a cada campo de contraseña de `root` el ojito para mostrarla u ocultarla. */
export function addPasswordToggles(root) {
    if (!root) return;
    root.querySelectorAll('input[type="password"]').forEach((input) => {
        if (input.parentNode.classList.contains('pw-eye-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'pw-eye-wrap';
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pw-eye';
        btn.innerHTML = '<span class="mi" aria-hidden="true">visibility</span>';
        const paint = () => {
            const shown = input.type === 'text';
            btn.querySelector('.mi').textContent = shown ? 'visibility_off' : 'visibility';
            btn.setAttribute('aria-label', t(shown ? 'login.pw.hide' : 'login.pw.show'));
            btn.setAttribute('aria-pressed', shown ? 'true' : 'false');
        };
        btn.addEventListener('click', () => {
            input.type = input.type === 'text' ? 'password' : 'text';
            paint();
            input.focus();
        });
        paint();
        wrap.appendChild(btn);
    });
}
